import { NavState } from '@/shared/types/app'

import { isChatMessagingNavState } from './chat-messaging-nav'

const WEB_CLIENT_ONLY_NAV_STATES = new Set<NavState>([
  NavState.CONTACTS,
  NavState.CALENDAR,
  NavState.NOTIFICATIONS,
])

export const isWebClientOnlyNavState = (state: NavState): boolean =>
  WEB_CLIENT_ONLY_NAV_STATES.has(state)

export const isWebClientNavState = (state: NavState): boolean =>
  isWebClientOnlyNavState(state) || isChatMessagingNavState(state)
